import React from 'react';

const SecondaryButton = ({label, href, className, children}) => {
    return <a
        href={href}
        className={"ml-4 inline-flex text-text-color bg-light-black border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg " + className}>{label || children}</a>
}

export default SecondaryButton;